(() => {
  const button = document.querySelector('.crystal-back-to-top');
  const sentinel = document.querySelector('.crystal-back-to-top-sentinel');

  if (!button || !sentinel) return;

  button.hidden = false;

  const setVisible = (visible) => {
    button.classList.toggle('is-visible', visible);
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      { rootMargin: '-220px 0px 0px 0px' }
    );

    observer.observe(sentinel);
  } else {
    setVisible(window.scrollY > 220);
  }

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });
})();
